const initState = {
  registerResponses: {
    success: null,
    error: null,
    code: null,
    message: null,
  },
};

export default initState;
